export default __webpack_public_path__ + "static/media/dados-de-contato.72de20f2.svg";